module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAc0lEQVR4Ae3MMQ5AQBBA0RH2ojqdWqWfS+i2U9G43BdZUQzFxjYi8w7w5Aecc3RMVPKAiok2txk4xHtFTeTQ50UjSaQ2zUwySh6UZKaRE83VqBg51ZIqAotpXlSBwGaaV9VqmoLKNGWVShm0qDGVinPuI3ZKQqCFdfwgWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Icons/expand-more.png
// module id = 973
// module chunks = 2